<template>
    <div class="result-out">
        <v-header headerTitle="专属审批事项清单" :isShowIcon="true"></v-header>
        <div class="result">
            <div class="title">关于威海市西涝台67#805房屋装修申请</div>
            <div class="card">
                <div class="card-title">
                    <div class="left">
                        <img src="@/assets/images/icon1.svg">
                        <span>立项用地规划许可</span>
                    </div>
                    <div class="edit" @click="edit('site')">
                        <i class="ri-edit-2-fill"></i>
                        <span>编辑</span>
                    </div>
                </div>
                <van-checkbox-group v-model="siteResult">
                    <van-cell-group>
                        <van-cell :title="`${index+1}、${item.name}`" v-for="(item, index) in siteList" :key="index">
                            <van-checkbox :name="item.id" v-if="siteVisible" />
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </div>
            <div class="card">
                <div class="card-title">
                    <div class="left">
                        <img src="@/assets/images/icon2.svg">
                        <span>工程建设许可</span>
                    </div>
                    <div class="edit" @click="edit('build')">
                        <i class="ri-edit-2-fill"></i>
                        <span>编辑</span>
                    </div>
                </div>
                <van-checkbox-group v-model="buildResult">
                    <van-cell-group>
                        <van-cell :title="`${index+1}、${item.name}`" v-for="(item, index) in buildList" :key="index">
                            <van-checkbox :name="item.id" v-if="buildVisible" />
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </div>
            <div class="card">
                <div class="card-title">
                    <div class="left">
                        <img src="@/assets/images/icon3.svg">
                        <span>施工许可</span>
                    </div>
                    <div class="edit" @click="edit('construte')">
                        <i class="ri-edit-2-fill"></i>
                        <span>编辑</span>
                    </div>
                </div>
                <van-checkbox-group v-model="construteResult">
                    <van-cell-group>
                        <van-cell :title="`${index+1}、${item.name}`" v-for="(item, index) in construteList" :key="index">
                            <van-checkbox :name="item.id" v-if="construteVisible" />
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>

            </div>
            <div class="card">
                <div class="card-title">
                    <div class="left">
                        <img src="@/assets/images/icon4.svg">
                        <span>竣工验收</span>
                    </div>
                    <div class="edit"  @click="edit('done')">
                        <i class="ri-edit-2-fill"></i>
                        <span>编辑</span>
                    </div>
                </div>
                <van-checkbox-group v-model="doneResult">
                    <van-cell-group>
                        <van-cell :title="`${index+1}、${item.name}`" v-for="(item, index) in doneList" :key="index">
                            <van-checkbox :name="item.id" v-if="doneVisible" />
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </div>
        </div>
        <div class="bot-btns">
            <van-button >保存</van-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "",
    components: {
        'v-header': () => import('@/components/VHeader/index.vue')
    },
    data() {
        return {
            siteList: [
                { id: '1', name: '新建、改建、扩建生产、储存危险化学品的建设项目安全条件审查' },
                { id: '2', name: '建设工程文物保护许可' },
                { id: '3', name: '一般工程抗震设防要求审定' },
                { id: '4', name: '建设用地规划许可证（延期）' },
                { id: '5', name: '涉及国家安全事项的建设项目新建、改建、扩建' },
            ],
            buildList: [
                { id: '1', name: '新建、改建、扩建生产、储存危险化学品的建设项目安全条件审查' },
                { id: '2', name: '建设工程文物保护许可' },
                { id: '3', name: '一般工程抗震设防要求审定' },
                { id: '4', name: '建设用地规划许可证（延期）' },
                { id: '5', name: '涉及国家安全事项的建设项目新建、改建、扩建' },
            ],
            construteList: [
                { id: '1', name: '新建、改建、扩建生产、储存危险化学品的建设项目安全条件审查' },
                { id: '2', name: '建设工程文物保护许可' },
                { id: '3', name: '一般工程抗震设防要求审定' },
                { id: '4', name: '建设用地规划许可证（延期）' },
                { id: '5', name: '涉及国家安全事项的建设项目新建、改建、扩建' },
            ],
            doneList: [
                { id: '1', name: '新建、改建、扩建生产、储存危险化学品的建设项目安全条件审查' },
                { id: '2', name: '建设工程文物保护许可' },
                { id: '3', name: '一般工程抗震设防要求审定' },
                { id: '4', name: '建设用地规划许可证（延期）' },
                { id: '5', name: '涉及国家安全事项的建设项目新建、改建、扩建' },
            ],
            active: 0,
            siteResult: [],
            siteVisible: false,
            buildResult: [],
            buildVisible: false,
            construteResult: [],
            construteVisible: false,
            doneResult: [],
            doneVisible: false,
        };
    },
    methods: {
        edit(type) {
            switch (type) {
                case 'site':
                    this.siteVisible = !this.siteVisible;
                    break;
                case 'build':
                    this.buildVisible = !this.buildVisible;
                    break;
                case 'construte':
                    this.construteVisible = !this.construteVisible;
                    break;
                case 'done':
                    this.doneVisible = !this.doneVisible;
                    break;
            }
        }
    },
};
</script>
<style lang="less" scoped>
.result {
    padding: 12px 16px;
    height: calc(100vh - 64px - 46px);
    overflow: scroll;
    .title {
        font-size: 18px;
        font-weight: 600;
        color: #000;
        margin-bottom: 16px;
    }

    .card {
        padding: 8px 0;
        border-radius: 6px;
        background: #FFF;

        .card-title {
            padding: 0 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            color: #0273C7;
            font-weight: 600;
            margin-bottom: 12px;

            img {
                width: 16px;
                height: 16px;
            }
            .left{
                display: flex;
                align-items: center;
                column-gap: 8px;
            }
            .edit{
                display: flex;
                align-items: center;
                column-gap: 4px;
                color: #0273C7;
                font-size: 14px;
                font-weight: 400;
            }
        }
        &:not(:last-child) {
            margin-bottom: 12px;
        }
    }
    ::v-deep{
        .van-hairline--top-bottom::after {
                border-width: 0;
            }

            .van-cell {
                align-items: center;
                column-gap: 10px;

                .van-cell__title {
                    order: 1;
                    font-size: 15px;
                    font-weight: 400;
                    color: #000;
                }

                .van-cell__value {
                    order: 0;
                    flex: 0 1 auto;
                }

            }

            .van-checkbox__icon {
                height: 16px;
                height: 16px;

                .van-icon {
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                }
            }

            .van-checkbox__icon--checked {
                .van-icon-success {
                    background: #0273C7;
                    color: #fff;
                }
            }
            .van-checkbox-group{
                .van-cell{
                    padding: 16px;
                    &::after{
                        border-bottom: 1px solid #eee;
                        left: 0;
                        right: 0;
                    }
                }
            }
    }
}
.bot-btns {
    background: #FFF;
    height: 64px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-button{
        width: 100%;
        border-radius: 6px;
        background: #0273C7;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
    }
}
</style>